export const validateCpfWithMessage = (cpf = "") => {
  const clean = cpf.replace(/\D/g, "");

  if (!clean) {
    return { valid: false, message: "Informe o CPF" };
  }

  if (clean.length < 11) {
    return { valid: false, message: "CPF incompleto" };
  }

  if (/^(\d)\1{10}$/.test(clean)) {
    return { valid: false, message: "CPF inválido" };
  }

  const calcDigit = (base) => {
    let sum = 0;
    let factor = base.length + 1;

    for (const digit of base) {
      sum += Number(digit) * factor--;
    }

    const result = (sum * 10) % 11;
    return result === 10 ? 0 : result;
  };

  const digit1 = calcDigit(clean.slice(0, 9));
  const digit2 = calcDigit(clean.slice(0, 10));

  if (digit1 !== Number(clean[9]) || digit2 !== Number(clean[10])) {
    return { valid: false, message: "CPF inválido" };
  }

  return { valid: true };
};
